module.exports = __webpack_public_path__ + "static/media/tonys-shoes-repair.0bbd1d6a.jpg";